import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, input, Output } from '@angular/core';
import { PaymentMethod } from '@models/payment-method';
import { PortalWidgetDetailsComponent } from '../portal-widget-details/portal-widget-details.component';
import { PortalActionButtonsComponent } from '../portal-action-buttons/portal-action-buttons.component';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-payment-method-widget-details',
    templateUrl: './payment-method-widget-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalWidgetDetailsComponent, DatePipe, PortalActionButtonsComponent, CtrlIconComponent],
})
export class PaymentMethodWidgetDetailsComponent {
    public paymentMethod = input.required<PaymentMethod>();
    @Input()
    public queued = false;

    @Output()
    public edit = new EventEmitter<void>();
    @Output()
    public add = new EventEmitter<void>();
    @Output()
    public delete = new EventEmitter<void>();

    protected bicDetail = computed(() =>
        (this.paymentMethod().bic ?? this.paymentMethod().iban.startsWith('DE'))
            ? 'Keine Angabe'
            : 'Nicht benötigt für Konten innerhalb Deutschlands',
    );
}
